/** Routerless page resolution: match window.location.pathname against the
 *  artifact's path_patterns. Most-specific match wins (static segments beat
 *  params; longer beats shorter). The host can override with a router-aware
 *  getCurrentPage — this is only the default. */

export function normalizePattern(pattern: string | undefined | null): string {
  if (!pattern) return '/'
  let n = pattern.startsWith('/') ? pattern : `/${pattern}`
  n = n.replace(/\/{2,}/g, '/')
  if (n.length > 1) n = n.replace(/\/+$/, '')
  return n.length > 0 ? n : '/'
}

const segments = (p: string): string[] => p.split('/').filter(Boolean)

function matchesPattern(pathSegs: string[], patternSegs: string[]): boolean {
  let required = patternSegs.length
  while (required > 0) {
    const last = patternSegs[required - 1]
    if (last !== undefined && last.startsWith(':') && last.endsWith('?')) required--
    else break
  }
  if (pathSegs.length < required || pathSegs.length > patternSegs.length) return false
  return pathSegs.every((seg, i) => {
    const pat = patternSegs[i]
    return pat !== undefined && (pat.startsWith(':') || pat === seg)
  })
}

export function resolvePage(pathname: string, patterns: ReadonlyArray<string>): string | null {
  const pathSegs = segments(normalizePattern(pathname))
  let best: string | null = null
  let bestScore = -1
  for (const pattern of patterns) {
    const patSegs = segments(pattern)
    if (!matchesPattern(pathSegs, patSegs)) continue
    const statics = patSegs.filter((s) => !s.startsWith(':')).length
    const score = statics * 100 + patSegs.length
    if (score > bestScore) { best = pattern; bestScore = score }
  }
  return best
}
